import type { GridAudioSoundPlayer } from "../GridLayer";
import type { ColumnLanding, GridLandReaction } from "./GridLandReaction";

/**
 * The default landing thud, once per landed column — UNLESS a cell in that column carries its own
 * land sound and asks to replace the thud (`suppressDefaultDropSound`, default true when a land
 * sound is set).
 */
export class DropThud implements GridLandReaction {
  private readonly audio: GridAudioSoundPlayer;
  private readonly soundId: string;

  public constructor(input: { audio: GridAudioSoundPlayer; soundId?: string }) {
    this.audio = input.audio;
    this.soundId = input.soundId ?? "column_drop";
  }

  public onColumnLanded(landing: ColumnLanding): void {
    if (isThudSuppressed(landing)) return;
    this.audio.playSoundId(this.soundId);
  }
}

/** True when any land-sounded cell in the column opted to replace the default thud. */
export function isThudSuppressed(landing: ColumnLanding): boolean {
  if (landing.views.length > 0) {
    return landing.views.some((view) => !!view.getCurrentLandSoundKey() && (view.getCurrentSuppressDefaultDropSound() ?? true));
  }
  return landing.definitions.some((definition) => {
    const soundId = (definition?.landSoundKey ?? "").trim();
    return soundId.length > 0 && (definition?.suppressDefaultDropSound ?? true);
  });
}
